import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import WhatshotIcon from '@mui/icons-material/Whatshot'; // Fire icon

const TrendingDivider = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        my: 4,
      }}
    >
      {/* Fire Icon with animation */}
      <div style={{ background: "white", borderRadius: "50%", paddingLeft: "9px", paddingTop: "5px", paddingBottom: "5px", marginRight: "5px" }}>
      <WhatshotIcon
        sx={{
          color: '#ff4500',
          mr: 1,
          animation: 'flicker 1.5s infinite',
          fontSize: '28px',
        }}
      />
      </div>
      
      {/* Text */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          color: '#ff4500',
          whiteSpace: 'nowrap',
          mr: 2,
        }}
      >
        Courses On High Demand
      </Typography>
      {/* Line filling the rest */}
      <Divider
        sx={{
          flexGrow: 1,
          borderColor: 'rgba(255, 69, 0, 0.6)',
          borderBottomWidth: 2,
        }}
      />

      {/* Flicker animation keyframes */}
      <style>
        {`
          @keyframes flicker {
            0%, 100% { opacity: 1; filter: drop-shadow(0 0 4px #ff4500); }
            50% { opacity: 0.7; filter: drop-shadow(0 0 8px #ff6347); }
          }
        `}
      </style>
    </Box>
  );
};

export default TrendingDivider;
